import { useEffect, useState } from 'react'
import { supabase } from './supabase'
import type { Notice, Opportunity, Programme, StudyResource } from '../types'

function decodeText(value:string){if(typeof document==='undefined')return value.replaceAll('&amp;','&').replaceAll('&quot;','"').replaceAll('&#039;',"'");const el=document.createElement('textarea');el.innerHTML=value;return el.value}

function mapResource(row:any):StudyResource{return{
  id:String(row.id),title:row.title,description:row.description??'',programme:row.programme??'General',subject:row.subject??'General',
  academic_period:row.academic_period??'',type:row.resource_type,year:row.resource_year,url:row.file_url,
  downloads:Number(row.download_count??0),is_featured:Boolean(row.is_featured),image_url:row.image_url,seo_title:row.seo_title,seo_description:row.seo_description,keywords:row.keywords,updated_at:row.updated_at,created_at:row.created_at,
}}

function mapNotice(row:any):Notice{return{
  id:String(row.id),title:decodeText(row.title??''),body:decodeText(row.content??''),category:row.category??'General',
  pinned:Boolean(row.is_pinned),image_url:row.image_url,button_text:row.button_text,button_url:row.button_url,meta_title:row.meta_title,meta_description:row.meta_description,meta_keywords:row.meta_keywords,updated_at:row.updated_at,created_at:row.created_at,
}}

function mapOpportunity(row:any):Opportunity{return{
  id:String(row.id),type:row.opportunity_type,title:decodeText(row.title??''),organisation:decodeText(row.organisation??''),
  description:decodeText(row.description??''),location:row.location,deadline:row.deadline,url:row.external_url,
  image_url:row.image_url,created_at:row.created_at,
}}

export function useResources(){
  const [resources,setResources]=useState<StudyResource[]>([]);const [loading,setLoading]=useState(true);const [error,setError]=useState('')
  useEffect(()=>{let active=true;supabase.from('resources').select('*').eq('is_active',true).order('created_at',{ascending:false}).limit(1000).then(({data,error})=>{if(!active)return;if(error)setError(error.message);else setResources((data??[]).map(mapResource));setLoading(false)});return()=>{active=false}},[])
  return{resources,loading,error}
}

export function useNotices(){
  const [items,setItems]=useState<Notice[]>([])
  useEffect(()=>{let active=true;supabase.from('notices').select('id,title,content,category,is_pinned,image_url,button_text,button_url,meta_title,meta_description,meta_keywords,created_at,updated_at').eq('is_active',1).order('is_pinned',{ascending:false}).order('created_at',{ascending:false}).limit(100).then(({data,error})=>{if(active&&!error&&data)setItems(data.map(mapNotice))});return()=>{active=false}},[])
  return items
}

export function useNotice(id?:string){
  const [item,setItem]=useState<Notice|null>(null);const [loading,setLoading]=useState(Boolean(id))
  useEffect(()=>{if(!id){setLoading(false);return}let active=true;setLoading(true);supabase.from('notices').select('id,title,content,category,is_pinned,image_url,button_text,button_url,meta_title,meta_description,meta_keywords,created_at,updated_at').eq('id',id).eq('is_active',1).maybeSingle().then(({data,error})=>{if(active){setItem(!error&&data?mapNotice(data):null);setLoading(false)}});return()=>{active=false}},[id])
  return{item,loading}
}

export function useOpportunities(type?:'Job'|'Intake'){
  const [items,setItems]=useState<Opportunity[]>([])
  useEffect(()=>{let active=true;let query=supabase.from('opportunities').select('*').eq('is_active',true);if(type)query=query.eq('opportunity_type',type);query.order('created_at',{ascending:false}).limit(100).then(({data,error})=>{if(active&&!error&&data)setItems(data.map(mapOpportunity))});return()=>{active=false}},[type])
  return items
}

export function useOpportunity(id?:string){
  const [item,setItem]=useState<Opportunity|null>(null);const [loading,setLoading]=useState(Boolean(id))
  useEffect(()=>{if(!id){setLoading(false);return}let active=true;setLoading(true);supabase.from('opportunities').select('*').eq('id',id).eq('is_active',true).maybeSingle().then(({data,error})=>{if(active){setItem(!error&&data?mapOpportunity(data):null);setLoading(false)}});return()=>{active=false}},[id])
  return{item,loading}
}

export function useProgrammes(){
  const [items,setItems]=useState<Programme[]>([])
  useEffect(()=>{let active=true;supabase.from('programmes').select('id,code,name,category,description').eq('is_active',true).order('display_order').order('code').then(({data,error})=>{if(active&&!error&&data)setItems(data.map((p:any)=>({...p,id:String(p.id)})))});return()=>{active=false}},[])
  return items
}


export type SiteGeneralSettings={
  site_name?:string;support_email?:string;support_phone?:string;primary_domain?:string;default_programme?:string;
  footer_description?:string;default_meta_description?:string;default_keywords?:string;whatsapp_url?:string;facebook_url?:string;
  home_kicker?:string;home_title?:string;home_highlight?:string;home_description?:string;home_search_placeholder?:string;
}

export function useSiteGeneral(){
  const[settings,setSettings]=useState<SiteGeneralSettings>({})
  useEffect(()=>{let active=true;supabase.from('site_settings').select('value').eq('key','general').maybeSingle().then(({data,error})=>{if(active&&!error&&data?.value)setSettings(data.value as SiteGeneralSettings)});return()=>{active=false}},[])
  return settings
}
